// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3ap6X","errorLogs":"EditorFooter_errorLogs__3osiW"};